import { scheduleEventKeys } from 'shared/hooks/schedule-events.hooks';
import { attendanceKeys } from 'shared/hooks/attendance.hooks';

// Check-in keys delegate to attendanceKeys so web invalidations hit the shared hooks' cache entries.
export const eventsKeys = {
  all: scheduleEventKeys.all,
  list: scheduleEventKeys.list,
  detail: scheduleEventKeys.detail,
  checkInSession: attendanceKeys.session,
  checkIns: attendanceKeys.checkIns,
};
